module.exports = __webpack_public_path__ + "static/media/firstaid.b625b4cb.png";